// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UseLongClick = require("../ui-utils/UseLongClick.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var HelpOutline = require("@mui/icons-material/HelpOutline").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;
var KeyboardReturn = require("@mui/icons-material/KeyboardReturn").default;

function makeInitialState() {
  return {
          newText: ""
        };
}

function setNewText(param, text) {
  return {
          newText: text
        };
}

function rndIconButton(icon, onClick, activeOpt, title, colorOpt) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  return React.createElement("span", {
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      onClick();
                    }),
                  color: color,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function MM_cmp_multiline_text(props) {
  var onDelete = props.onDelete;
  var onHelp = props.onHelp;
  var __fullWidth = props.fullWidth;
  var __width = props.width;
  var renderer = props.renderer;
  var __longClickDelayMs = props.longClickDelayMs;
  var __longClickEnabled = props.longClickEnabled;
  var __editByAltClick = props.editByAltClick;
  var __editByClick = props.editByClick;
  var onEditCancel = props.onEditCancel;
  var onEditDone = props.onEditDone;
  var onEditRequested = props.onEditRequested;
  var editMode = props.editMode;
  var text = props.text;
  var editByClick = __editByClick !== undefined ? __editByClick : true;
  var editByAltClick = __editByAltClick !== undefined ? __editByAltClick : false;
  var longClickEnabled = __longClickEnabled !== undefined ? __longClickEnabled : false;
  var longClickDelayMs = __longClickDelayMs !== undefined ? __longClickDelayMs : 10000;
  var width = __width !== undefined ? __width : 600;
  var fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  var match = React.useState(function () {
        return {
                newText: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setNewTextCursorPosition = match$1[1];
  var newTextCursorPosition = match$1[0];
  var textFieldRef = React.useRef(null);
  var match$2 = UseLongClick.useLongClick(editByClick ? (
          editByAltClick ? MM_react_common.clickHnd2(MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, onEditRequested), MM_react_common.clickClbkMake(undefined, true, undefined, undefined, onEditRequested)) : MM_react_common.clickHnd(undefined, undefined, undefined, undefined, onEditRequested)
        ) : (
          editByAltClick ? MM_react_common.clickHnd(undefined, true, undefined, undefined, onEditRequested) : (function (param) {
                
              })
        ), longClickEnabled && editByAltClick, longClickDelayMs, (function (clickAttrs) {
          if (clickAttrs === undefined) {
            return ;
          }
          var alt = clickAttrs.alt;
          if (editByClick && !alt || editByAltClick && alt) {
            return onEditRequested();
          }
          
        }), onEditRequested);
  var onTouchCancel = match$2.onTouchCancel;
  var onTouchMove = match$2.onTouchMove;
  var onTouchEnd = match$2.onTouchEnd;
  var onTouchStart = match$2.onTouchStart;
  var onMouseOut = match$2.onMouseOut;
  var onMouseLeave = match$2.onMouseLeave;
  var onMouseMove = match$2.onMouseMove;
  var onMouseUp = match$2.onMouseUp;
  var onMouseDown = match$2.onMouseDown;
  var onClick = match$2.onClick;
  React.useEffect((function () {
          if (editMode) {
            setState(function (__x) {
                  return {
                          newText: text
                        };
                });
          }
          
        }), [editMode]);
  React.useEffect((function () {
          if (newTextCursorPosition !== undefined) {
            setNewTextCursorPosition(function (param) {
                  
                });
            var domElem = textFieldRef.current;
            if (!(domElem == null)) {
              domElem.selectionStart = newTextCursorPosition;
              domElem.selectionEnd = newTextCursorPosition;
            }
            
          }
          
        }), [newTextCursorPosition]);
  var actNewTextUpdated = function (newText) {
    setState(function (__x) {
          return {
                  newText: newText
                };
        });
  };
  var actEditDone = function () {
    onEditDone(state.newText.trim());
  };
  var actEditCancel = function () {
    onEditCancel(state.newText.trim());
  };
  var actStartNewLine = function () {
    var domElem = textFieldRef.current;
    if (domElem == null) {
      return ;
    }
    var selectionStart = domElem.selectionStart;
    var before = state.newText.substring(0, selectionStart);
    var after = state.newText.substring(selectionStart);
    actNewTextUpdated(before + "\n" + after);
    domElem.focus();
    setNewTextCursorPosition(function (param) {
          return selectionStart + 1 | 0;
        });
  };
  var rndButtons = function () {
    var saveBtn = rndIconButton(React.createElement(Save, {}), actEditDone, true, "Save, Enter", undefined);
    var cancelBtn = rndIconButton(React.createElement(CancelOutlined, {}), actEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined));
    var helpBtn = onHelp !== undefined ? rndIconButton(React.createElement(HelpOutline, {}), onHelp, undefined, "Help", Caml_option.some(undefined)) : null;
    var deleteBtn = onDelete !== undefined ? rndIconButton(React.createElement(DeleteForever, {}), onDelete, undefined, "Clear", Caml_option.some(undefined)) : null;
    var newLineBtn = rndIconButton(React.createElement(KeyboardReturn, {}), actStartNewLine, true, "Start new line, Shift+Enter", Caml_option.some(undefined));
    return React.createElement(Expln_React_Row.make, {
                spacing: 1,
                children: Caml_option.some(null)
              }, saveBtn, newLineBtn, cancelBtn, helpBtn, deleteBtn);
  };
  var rndText = function () {
    if (editMode) {
      var width$1;
      if (fullWidth) {
        var windowWidth = window.innerWidth;
        width$1 = windowWidth - 200 | 0;
      } else {
        width$1 = width;
      }
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(TextField, {
                      inputRef: Caml_option.some(textFieldRef),
                      value: state.newText,
                      size: "small",
                      style: {
                        width: String(width$1) + "px"
                      },
                      multiline: true,
                      onChange: Expln_React_common.evt2str(actNewTextUpdated),
                      onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actEditDone), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actEditCancel)),
                      autoFocus: true,
                      title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                    }), rndButtons());
    }
    var style = text.trim() === "" ? ({
          padding: "4px"
        }) : ({
          padding: "0px 4px"
        });
    var title = editByAltClick ? (
        longClickEnabled ? "<long-click> (Alt + <left-click>) to change" : "Alt + <left-click> to change"
      ) : "<left-click> to change";
    return React.createElement(Paper, {
                style: style,
                variant: "outlined",
                title: title,
                onClick: onClick,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onMouseMove: onMouseMove,
                onMouseLeave: onMouseLeave,
                onMouseOut: onMouseOut,
                onTouchStart: onTouchStart,
                onTouchEnd: onTouchEnd,
                onTouchMove: onTouchMove,
                onTouchCancel: onTouchCancel,
                children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Belt_Option.getExn(renderer)(text))
              });
  };
  return rndText();
}

var make = MM_cmp_multiline_text;

exports.makeInitialState = makeInitialState;
exports.setNewText = setNewText;
exports.rndIconButton = rndIconButton;
exports.make = make;
/* react Not a pure module */
